import isProductSoldOut from './isProductSoldOut';

export default (product) => {
    const { notStockedOnline } = product;
    let availability;

    if (isProductSoldOut(product)) {
        availability = 'SoldOut';
    } else if (notStockedOnline) {
        availability = 'InStoreOnly';
    } else {
        availability = 'InStock';
    }

    return availability;
};
